import React, { useContext, useState } from "react";
import {
  Form,
  Input,
} from "reactstrap";
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { Redirect, Link } from "react-router-dom";
import "../../css/login.css";
import { UserContext } from "../../context/UserContext";

const SignUp = () => {
  const context = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(false);
  // const [password,setPassword]=useState('')
  const logindata = {
    email: "",
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    checklogin();
  };
  const checklogin = async () => {
    if (email === "") {
      toast.error("Please Enter valid Credentials", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isEmail(email)) {
      toast.error("Please Enter valid Email", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    await Axios.post("Login/checklogin", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.exist === "true") {
          toast.error("You are already Register,Please Login", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setEmail("");
          return res;
        } else if (res.data.status === "200" && res.data.exist === "false") {
          toast.success("Otp sent to " + res.data.email, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          context.setUser({ otpemail: email })
          console.log(otp)
          setOtp(true);
        }
      })
      .catch((error) => {
        console.log("error123", error);
      });
  };
  if (context.user?.otpemail) {
    return <Redirect to="/Verification" />
  }
  return (
    <div>
      <div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
        <div class="">
          <div class="row d-flex">
            <div class="col-lg-6"><br />
              <div class="card2 card border-0 px-4 py-5">
                <div class="row mb-4 px-3 text-center">
                  <div class="col-lg-12 text-center">
                    <center>
                      <h6 class="mb-0 mr-4 mt-1" >New to Eduplusnow</h6>
                    </center>
                  </div>
                </div>
                <div class="row px-3 mb-4">
                  <div class="line"></div> <span class="or text-center">Sign up</span>
                  <div class="line"></div>
                </div>
                <Form onSubmit={handleFormSubmit} class="sign-in-form test-form-sign">
                  <div class="row px-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">Email Address</h6>
                  </label>
                    <Input className="mb-4"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="provide your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div class="row mb-3 px-3"> <button type="submit" class="btn btn-blue text-center">Register</button> </div>
                </Form>
                <div class="row mb-4 px-3"> <small class="font-weight-bold">Already Register?<Link tag={Link} class="text-danger " to="/Signin"><u>Sign in</u></Link> </small> </div>
                <div class="row px-3 ">
                  <div class="line-follow"></div> <small class="or-follow text-center">Follow us</small>
                  <div class="line-follow"></div>
                </div>
                <div class="row mr-l">
                  <div class="facebook text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.facebook.com/eduplusnow/'} ><FacebookIcon /></a>
                  </div>
                  <div class="twitter text-center mr-3">{// eslint-disable-next-line
                  } <a href={'href="https://www.youtube.com/channel/UCtkn64AR1Qrmk2Z-o0bzzsA"'} ><YouTubeIcon /></a>
                  </div>
                  <div class="linkedin text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.linkedin.com/company/edu-plus-now/'} >
                      <LinkedInIcon /></a>
                  </div>
                  <div class="insta text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.instagram.com/eduplusnow/'} >
                      <InstagramIcon /></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card1 pb-5">
                <div class="row">  </div>
                <div class="row px-3 justify-content-center mt-4 mb-5 border-line-left">  <img alt="executive2" width="" src="/assets/images/ban-image.png" /> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
